import $ from "jquery";

const gformFileUploadCustom = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: '.gform_wrapper .gfield .ginput_container_fileupload input[type="file"]'
        }
        if ($(el.main).length === 0) return

        $(function ($) {
            $(el.main).each(function () {
                const $input = $(this);

                // add or create wrapper div and custom element
                const $wrapper = $('<div class="custom-file-upload"></div>');
                const $btn = $('<label class="upload-btn">Datei auswählen</label>');
                const $fileName = $('<span class="file-name">Keine Datei ausgewählt</span>');

                // hide input and move into wrapper
                $input.css({ display: 'none' });
                $input.wrap($wrapper);
                $input.before($btn);
                $input.after($fileName);

                // trigger click input
                $btn.on('click', function (e) {
                    e.preventDefault();
                    $input.trigger('click');
                });

                // Update name file after selected file
                $input.on('change', function () {
                    const name = this.files.length > 0 ? this.files[0].name : 'Keine Datei ausgewählt';
                    $fileName.text(name);
                });
            });
        });
    };

    init();
};

try {
    gformFileUploadCustom();
} catch (error) {
    console.error('gformFileUploadCustom', error);
}
